import React from "react";
import domainI from '../../images/home/domain-hosting.png';

function DomainHosting() {
  return (
    <>

      <Hero />

      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={domainI}
                alt="Domain and Hosting"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">

                <h2>Everything You Need To Establish Your Online Presence</h2>

                <p>
                  Getting your business online requires more than just a
                  website. You also need a suitable domain and reliable
                  hosting environment.
                </p>

                <p>
                  We can help clients with domain registration, hosting
                  requirements, website deployment, and the basic technical
                  setup needed to maintain their online presence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-features-section">
        <div className="container">
          <div className="section-heading text-center">

            <h2>Domain & Hosting Services</h2>
          </div>

          <div className="row g-4">
            {[
              ["Domain Registration", "Choose and register a domain that represents your business."],
              ["Web Hosting", "Hosting solutions for websites and web applications."],
              ["Website Deployment", "Help with deploying your website and getting it online."]
            ].map(([title, text]) => (
              <div className="col-lg-4 col-md-6" key={title}>
                <div className="service-feature-card">
                  <h3>{title}</h3>
                  <p>{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}

function Hero() {
  return (
    <section
      className="service-page-hero"
      style={{ backgroundColor: '#002952' }}
    >
      <div className="container">
        <div className="service-hero-content">

          <h1>Domain & Hosting</h1>
          <p style={{ color: '#FF7D37' }}>
            Domain and hosting solutions to help <br /> business establish a
            reliable online presence.
          </p>
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>
            <span>GET ONLINE</span>
            <h2>Ready To Take Your Business Online?</h2>
            <p>Let's discuss your domain, hosting, and website requirements.</p>
          </div>
          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default DomainHosting;